import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDatepickerInputEvent, MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'jalali-moment';
import { Txn_Expense } from '../../../models/Txn_Expense';


@Component({
  selector: 'app-edit-expense-dialog',
  templateUrl: './edit-expense-dialog.component.html',
  styleUrls: ['./edit-expense-dialog.component.css']
})
export class EditExpenseDialogComponent implements OnInit {
  trn_ref_no: string;
  expense_remark: string;
  value_date: Date;
  

  this_exp: Txn_Expense = {
    id:0,
    authStat: '',
    checkerID: '',
    expense_amount: 0,
    documentNo: '',
    value_date: null,
    expense_remark: '',
    makerID: '',
    GL_CR: '',
    GL_DR: '',
    trn_ref_no: '',
    userId: '',
    branchId: 0,
    statusId: 2,
    branchTitle: '',
    statusTitle: '',
    addressExpFile: '',
    isPrint:false,
  }
  constructor(
    public dialogRef: MatDialogRef<EditExpenseDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    this.trn_ref_no = data.trn_ref_no;
    this.value_date = new Date(data.value_date);
    this.expense_remark = data.expense_remark;

  }
  DateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.value_date = new Date(_date);
    console.log(this.value_date);
    //this.fromDate_DariDate = _pdate;
  }

  updateInvoice() {
    this.this_exp.value_date = this.value_date;
    this.this_exp.expense_remark = this.expense_remark;
    this.this_exp.trn_ref_no = this.trn_ref_no;

    //this.invoice_service.updateInvoice(this.this_inv);

    this.dialogRef.close({ event: 'close', data: this.this_exp });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: this.this_exp });
  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/components/management/edit-expense-dialog/edit-expense-dialog.component.ts